<script setup lang="ts">
import DoneCard from "@/components/done/DoneCard.vue";
import { defineProps, ref } from "vue";
import store from "@/store";

const props = defineProps({
  orders: Array,
  readonly: {
    default: false,
  },
});

const activeOrder = ref(null as string | null);

const setActiveOrder = (index: string) => {
  activeOrder.value = index;
};
</script>

<template>
  <div
    v-if="store?.state?.OrderStore?.done.length"
    id="orders"
    class="flex flex-col gap-3 pb-[150px]"
  >
    <DoneCard
      v-for="(order, index) in orders"
      :key="index"
      :index="index"
      :order="order"
      :readonly="readonly"
      :active-order="activeOrder"
      @activeOrder="setActiveOrder"
    ></DoneCard>
  </div>
  <div class="absolute z-1 inset-0 flex items-center justify-center" v-else>
    <span class="text-gray-500 w-40">{{ $t("done.empty") }}</span>
  </div>
</template>
